
import { Form } from "element-ui";
import { Vue, Component, Prop, Watch, Ref } from "vue-property-decorator";
export interface PropEditorModel {
  groupName: string;
  propName: string;
  propValue: string;
}
@Component
export default class PropEditor extends Vue {
  @Prop({ required: false }) groupName?: string;
  @Ref("form") elForm!: Form;
  form: PropEditorModel = {
    groupName: "",
    propName: "",
    propValue: "",
  };
  get rules() {
    return {
      groupName: [
        { required: !this.groupName, message: "请输入分组", trigger: "blur" },
      ],
      propName: [
        { required: true, message: "请输入属性名称", trigger: "blur" },
      ],
    };
  }
  @Watch("groupName")
  handleGroupNameChange(val: string) {
    this.form.groupName = val;
  }
  cancel() {
    this.form.groupName = "";
    this.form.propName = "";
    this.form.propValue = "";
    this.$emit("cancel");
  }
  async validate() {
    return await this.elForm.validate().catch(() => false);
  }
  async save() {
    if (!(await this.validate())) {
      return;
    }
    this.$emit("done", {
      ...this.form,
      groupName: this.groupName || this.form.groupName,
    });
  }
}
